import camelCase            from 'lodash/camelCase'
import WizardController     from '../../../wizard_controller'
import SmokingHabitsMixin   from '../../../medical_histories/smoking_habits_mixin'
import mixin                from '../../../../support/mixin'

export default class extends mixin(WizardController, SmokingHabitsMixin) {

  static targets = [
    ...super.targets,
    'allHospitalisationHistory',
    'chronicMedicationNoneInverse',
    'drinksDetails',
    'hospitalisationHistoryDetails',
    'hospitalisationHistoryDetailsInput',
    'hypoglycaemicEpisodes',
    'itemDetails',
    'ketoacidosisEpisodes',
    'nestedTextInput',
    'nestedTextTemplate',
    'nestedTextWrapper',
    'otherChronicMedicationDetailsInput',
    'otherChronicMedicationDetailsTemplate',
    'otherChronicMedicationDetailsWrapper',
    'otherHospitalHistoryDetails',
    'otherHospitalHistoryDetailsInput',
    'sexualConcernsNoneOfTheAbove',
    'singleCheckBoxDetails',
    'stoppedDrinkingDetails'
  ]

  toggleNoneOfTheAbove({ currentTarget, params: { sectionType } }) {
    const targetsKey = camelCase(`${sectionType}_none_of_the_above_targets`)

    this.toggleCheckboxNoneOfTheAbove({
      input:         currentTarget,
      targets:       this[targetsKey],
      dispatchInput: false
    })
  }

  // === Nested inputs

  addNestedTextInputItem() {
    this.addNestedForm({
      list:     this.nestedTextInputTargets,
      template: this.nestedTextTemplateTarget,
      wrapper:  this.nestedTextWrapperTarget
    })
  }

  removeNestedTextInputItem(event) {
    const currentTarget = event.currentTarget

    this.removeNestedForm({
      button:  currentTarget,
      wrapper: this.nestedTextWrapperTarget,
      list:    this.nestedTextInputTargets
    })

    if (this.hasConsultationNoteOutlet) {
      this.consultationNoteOutlet.autoSave(event)
    }
  }

  toggleSectionItemDetails({ currentTarget }) {
    const detailsSection = currentTarget.dataset.detailsSection

    this.toggleCheckboxMoreDetails({
      input:  currentTarget,
      target: this.itemDetailsTargets.find((target) => target.dataset.detailsSection === detailsSection)
    })
  }

  toggleNestedSectionItemDetails({ currentTarget }) {
    const nested = this.itemDetailsTargets.find((target) => target.dataset.detailsSection === currentTarget.value)
    if (!nested) return

    this.toggleCheckboxMoreDetails({
      input:  currentTarget,
      target: nested
    })
  }

  toggleSingleCheckBoxDetails({ currentTarget }) {
    this.toggleNoneInverseSelection({
      input:  currentTarget,
      target: this.singleCheckBoxDetailsTarget
    })
  }

  // Hospital History

  toggleOtherHospitalHistoryDetails(event) {
    this.toggleCheckboxMoreDetails({
      input:  event.currentTarget,
      target: this.otherHospitalHistoryDetailsTarget
    })
  }

  addHospitalisationHistoryDetailsItem() {
    this.addNestedForm({
      list:      this.hospitalisationHistoryDetailsInputTargets,
      inputType: "input[type='text']",
      wrapper:   this.hospitalisationHistoryDetailsTarget
    })
  }

  removeHospitalisationHistoryDetailsItem(event) {
    this.removeNestedForm({
      button:    event.currentTarget,
      wrapper:   this.hospitalisationHistoryDetailsTarget,
      list:      this.hospitalisationHistoryDetailsInputTargets,
      inputType: "input[type='text']"
    })
  }

  toggleNoneInverseHospitalisationHistory(event) {
    this.toggleNoneInverseSelection({
      input:  event.currentTarget,
      target: this.noneInverseHospitalisationHistoryTarget
    })
  }

  // Alcohol use

  toggleDrinkingStatusDetails({ currentTarget }) {
    [
      { value: 'stopped_drinking', target: this.stoppedDrinkingDetailsTarget },
      { value: 'drinks', target: this.drinksDetailsTarget }
    ].forEach((obj) => {
      if (currentTarget.value === obj.value) {
        this.showRadioButtonMoreDetails({
          target: obj.target
        })
      } else {
        this.hideRadioButtonMoreDetails({
          target: obj.target
        })
      }
    })
  }

  // Chronic medication

  addOtherChronicMedicationDetailsInputItem() {
    this.addNestedForm({
      list:     this.otherChronicMedicationDetailsInputTargets,
      template: this.otherChronicMedicationDetailsTemplateTarget,
      wrapper:  this.otherChronicMedicationDetailsWrapperTarget
    })
  }

  removeOtherChronicMedicationDetailsInputItem(event) {
    this.removeNestedForm({
      button:  event.currentTarget,
      wrapper: this.otherChronicMedicationDetailsWrapperTarget,
      list:    this.otherChronicMedicationDetailsInputTargets
    })

    if (this.hasConsultationNoteOutlet) {
      this.consultationNoteOutlet.autoSave(event)
    }
  }

  toggleChronicMedicationNoneInverse({ currentTarget }) {
    this.toggleTarget(this.chronicMedicationNoneInverseTarget, !currentTarget.checked)
  }

  toggleAllHospitalisationHistory() {
    const isKetoacidosisEpisodesSelected = this.ketoacidosisEpisodesTarget.checked && this.ketoacidosisEpisodesTarget.value === 'yes'
    const isHypoglycaemicEpisodesSelected = this.hypoglycaemicEpisodesTarget.checked && this.hypoglycaemicEpisodesTarget.value === 'yes'
    this.toggleTarget(this.allHospitalisationHistoryTarget, (isKetoacidosisEpisodesSelected || isHypoglycaemicEpisodesSelected))
  }

}
